import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const createInitialState = () => ({
  requestId: undefined,
  total: undefined,
});

export default handleActions(
  {
    [Actions.LOAD_PREVIEW_NUMBER_OF_LISTINGS_START]: (
      state,
      { payload: requestId },
    ) => ({
      ...state,
      requestId,
    }),
    [Actions.LOAD_PREVIEW_NUMBER_OF_LISTINGS_DONE]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    [Actions.LOAD_PREVIEW_NUMBER_OF_LISTINGS_CLEAR]: createInitialState,
  },
  createInitialState(),
);

export const getPreviewNumberOfListings = state => state.total;
export const getPreviewRequestId = state => state.requestId;
